export default {
  name: 'SystemMessage',
  props: {
    data: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  mounted: function mounted() {
    this.$emit('scrollToEnd');
  }
};